import React from "react";
import styled from "styled-components";
import { ChevronLeft, ChevronRight } from "@sonder/ui/source/icons";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { InputGroup } from "@sonder/ui/source/styled/fragments/InputGroup";

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 0.8rem;
  margin-top: 0.5rem;
`;

interface PaginationProps extends React.InputHTMLAttributes<HTMLDivElement> {
  hasNext: boolean;
  hasPrev: boolean;
  onNextClick?(e: React.MouseEvent): void;
  onPrevClick?(e: React.MouseEvent): void;
}
export const Pagination = ({
  className,
  hasPrev,
  hasNext,
  onPrevClick = () => undefined,
  onNextClick = () => undefined,
}: PaginationProps) => {
  return (
    <PaginationWrapper className={className}>
      <InputGroup>
        {hasPrev && (
          <Button iconLeft onClick={onPrevClick}>
            <ChevronLeft />
            Previous Page
          </Button>
        )}
        {hasNext && (
          <Button iconRight onClick={onNextClick}>
            Next Page
            <ChevronRight />
          </Button>
        )}
      </InputGroup>
    </PaginationWrapper>
  );
};
